import {type ChangeEvent, useCallback, useState} from 'react';
import {useDebounce} from './use-debounce';

type UseSearchInputProps = {
  value?: string;
  onChange?: (value: string) => void;
};

export function useSearchInput({value, onChange}: UseSearchInputProps) {
  const [innerValue, setInnerValue] = useState(value || '');
  const [, setDebouncedValue] = useDebounce(innerValue, 600, onChange);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.value === '') {
        setDebouncedValue('');
      }

      setInnerValue(event.target.value);
    },
    [setDebouncedValue],
  );

  const reset = innerValue
    ? () => {
        if (!innerValue) {
          return;
        }

        setInnerValue('');
        setDebouncedValue('');
      }
    : undefined;

  return {innerValue, handleChange, reset};
}
